import { Form } from "../../Form/Form";
import styles from "./ShopForm.module.css";
import { createPortal } from "react-dom";
import { AiOutlineCloseCircle } from "react-icons/ai";

function ShopForm({ setShowShoppingCart }) {
  return createPortal(
    <>
      <div
        className={styles.container}
        onClick={() => setShowShoppingCart(false)}
      ></div>
      <div className={styles.containerShopping}>
        <AiOutlineCloseCircle
          onClick={() => setShowShoppingCart(false)}
          className={styles.close}
        ></AiOutlineCloseCircle>
        <div className={styles.containerText}>
          {" "}
          <h3>Quiero un amigurumi</h3>
          <p>
            "Si necesitás hacer un pedido personalizado para un evento especial
            escribime a través de algunas de mis redes o en el formulario que
            aparece en esta página. Si necesitas inspiración mira mi galería de
            fotos 📸. También podés seguirme en Instagram o Facebook para
            conocer en cuáles mercadillos estaré presente este mes para poder
            ver personalmente mis productos 😎.",
          </p>
        </div>

        <Form
          messageLabel="Tu pedido"
          initialMessage="¡Hola! Necesito un amigurumi de oso para regalarle a mi amigo."
        ></Form>
      </div>
    </>,
    document.getElementById("portal")
  );
}

export { ShopForm };
